import React, { useState, useEffect, useCallback } from "react";
import { SectionWrapper } from "../../../styles/common";
import TabButton from "../../core/Button/TabButton";
import {
  ACCESS_TABLE_HEADER,
  EVENT_ITEMS,
  HEADER_KEYS,
  PROBING_TABLE_HEADER
} from "../../../constants";
import ColorInfo from "../../shared/ui/ColorInfo";
import Table from "../../shared/ui/Table";

const MalligyongEventTable = props => {
  const { accessTableData, probingTableData, selectedData, handleSelectData } =
    props;

  const selectedEvent = selectedData[HEADER_KEYS.TYPE];
  const selectedSubEvent = selectedData[HEADER_KEYS.NAME];
  const eventTable =
    selectedEvent === "Access" ? accessTableData : probingTableData;

  const tableData = eventTable[selectedSubEvent];
  const tableHeader =
    selectedEvent === "Access" ? ACCESS_TABLE_HEADER : PROBING_TABLE_HEADER;

  const secondaryTabData = Object.keys(eventTable).map(key => ({
    value: key,
    label: key
  }));

  const [selectedRow, setSelectedRow] = useState(0);

  const handleSelectEvent = event => {
    const eventTable = event === "Access" ? accessTableData : probingTableData;
    const initialKey = Object.keys(eventTable)[0];
    const initialData = eventTable[initialKey][0];

    handleSelectData(initialData);
  };

  const handleSelectSubEvent = subEvent => {
    const initialData = eventTable[subEvent][0];
    handleSelectData(initialData);
  };

  const handleClickDataRow = useCallback(
    index => {
      const data = tableData[index];
      handleSelectData(data);
      setSelectedRow(index);
    },
    [handleSelectData, tableData]
  );

  useEffect(() => {
    if (!!!tableData || tableData.length === 0) return;
    handleSelectData(tableData[0]);
    handleClickDataRow(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableData]);

  return (
    <MalligyongEventTableUI
      selectedEvent={selectedEvent}
      selectedSubEvent={selectedSubEvent}
      selectedData={selectedData}
      handleSelectEvent={handleSelectEvent}
      secondaryTabData={secondaryTabData}
      handleSelectSubEvent={handleSelectSubEvent}
      tableHeader={tableHeader}
      tableData={tableData}
      handleSelectData={handleSelectData}
      selectedRow={selectedRow}
      handleClickDataRow={handleClickDataRow}
    />
  );
};

export default MalligyongEventTable;

const MalligyongEventTableUI = ({
  selectedEvent,
  selectedSubEvent,
  selectedData,
  handleSelectEvent,
  secondaryTabData,
  handleSelectSubEvent,
  tableHeader,
  tableData,
  handleClickDataRow,
  selectedRow
}) => {
  return (
    <SectionWrapper>
      <h2 className="title">Event Report</h2>
      {/* <h3 className="subtitle">(Click a city/satellite name)</h3> */}
      <main className="content content__low-height">
        {/* first row tabs */}
        <section className="tab-wrapper">
          <TabButton
            tabs={EVENT_ITEMS}
            activeTab={selectedEvent}
            onTabChange={handleSelectEvent}
          />
          {selectedEvent === "Access" && <ColorInfo />}
        </section>
        {/* second row tabs */}
        <section className="tab-wrapper">
          <TabButton
            tabs={secondaryTabData}
            activeTab={selectedSubEvent}
            onTabChange={handleSelectSubEvent}
          />
        </section>
        <Table
          tableHeader={tableHeader}
          tableData={tableData}
          handleSelectData={handleClickDataRow}
          selectedRow={selectedRow}
        />
      </main>
    </SectionWrapper>
  );
};
